import InboxMembersAPI from '../../api/inboxMembers';

export const actions = {
  // `get` / `create` are kept for legacy callers (Campaigns / older flows).
  // `show` / `update` mirror the REST verbs and are what the inbox settings
  // page (CollaboratorsPage) uses; they call the same API methods.
  get(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  show(_, { inboxId }) {
    return InboxMembersAPI.show(inboxId);
  },
  create(_, { inboxId, agentList }) {
    return InboxMembersAPI.update({ inboxId, agentList });
  },
  update(_, { inboxId, agentList }) {
    return InboxMembersAPI.update({ inboxId, agentList });
  },
};

export default {
  namespaced: true,
  actions,
};
